import { Toast, type ToastVariant } from '@/shared-ui/atoms';

export interface ToastContentProps {
    description: string;
    title: string;
    onClose: () => void;
    variant: ToastVariant;
}

export const ToastContent = ({ description, title, onClose, variant }: ToastContentProps) => {
    return <Toast description={description} onClose={onClose} title={title} variant={variant} />;
};
